export enum MainRoutes {
  HOME = '/',
  SIGN_IN = '/sign-in',
  SIGN_UP = '/sign-up'
}
